import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import { EditActions, editActions } from "../../actions/editActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector,
  domainSelector
} from "../../reducers/editReducer";
import {
  GroupParametersTable,
  setGroupParameterExtraProperties
} from "./Parameters/GroupParametersTable";
import { GroupFaultsTable } from "./Faults/GroupFaultsTable";
import { ParameterCategoriesTable } from "../common/ParameterCategories/ParameterCategoriesTable";
import {
  setFaultExtraProperties,
  createEmptyParameter,
  createEmptyFault,
  createEmptyParameterCategory,
  setParameterCategoryEnumExtraProperties
} from "../../utils/pdApiUtils";
import { ActionMenu } from "../common/ActionMenu/ActionMenu";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import { mainActions, MainActions } from "../../actions/mainActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";

type StateProps = {
  pdApi: State.PdApi | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  domainName: string;
  isLoadingParameters: boolean;
  isLoadingFaults: boolean;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  columnActions: typeof columnActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.GroupSubmenu;
  userFiltering?: Filter[];
};

// Props of the component
export type GroupProps = StateProps & DispatchProps & OwnProps;

type GroupState = {
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.GroupSubmenu]: Filter[];
  };
};

export class Group extends React.Component<GroupProps, GroupState> {
  state = {
    isModalOpen: false,
    tableColumnFilters: {
      "Group Faults": [],
      "Group Parameters": [],
      "Parameter Categories": []
    }
  };
  private groupName: Api.GroupName = "Group";
  /**
   * To add new sub page to this parent, add it here
   */
  subPages: Internal.SubPages = {
    "Group Parameters": {
      itemName: "parameter",
      PdApiField: "groupParameters",
      dataView: GroupParametersTable,
      createEmpty: createEmptyParameter,
      setExtraProperties: setGroupParameterExtraProperties
    },

    "Group Faults": {
      itemName: "fault",
      PdApiField: "groupFaults",
      dataView: GroupFaultsTable,
      createEmpty: createEmptyFault,
      setExtraProperties: setFaultExtraProperties
    },

    "Parameter Categories": {
      itemName: "parameter category",
      PdApiField: "parameterCategories",
      dataView: ParameterCategoriesTable,
      createEmpty: createEmptyParameterCategory,
      setExtraProperties: setParameterCategoryEnumExtraProperties
    }
  };
    componentDidMount(): void {
      if (
        this.props.pdApi.driveFaults === undefined &&
        window.location.href.includes("group/faults")
      ) {
        this.props.pdApiActions.fetchGroupFaults();
      }
    }
  render(): JSX.Element {
    const { subMenuRoute } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submenuLinks = Object.keys(this.subPages).map((subPageName: any) =>
      this.buildLink(subPageName)
    );
    const actionMenu = this.getActionMenu(subMenuRoute);
    const dataView = this.getDataView(subMenuRoute);
    const modal = this.buildModal();

    return (
      <>
        <ContentLayout submenu={submenuLinks} actionMenu={actionMenu} dataView={dataView} />
        {modal}
      </>
    );
  }

  private setColumnFilters = (subMenuRoute: State.GroupSubmenu, newFilters: Filter[]): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subMenuRoute: State.GroupSubmenu): JSX.Element => {
    if (subMenuRoute === "Parameter Categories") {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters,
        groupName: "Group"
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    } else if (subMenuRoute in this.subPages) {
      const passProps = {
        ...this.props,
        toggleModal: this.toggleModal,
        setColumnFilters: this.setColumnFilters
      };
      return React.createElement(this.subPages[subMenuRoute].dataView, passProps);
    }
    return <>Error</>;
  };

  private getActionMenu = (subMenuRoute: State.GroupSubmenu): JSX.Element | null => (
    <ActionMenu
      {...this.props}
      itemName={this.subPages[subMenuRoute].itemName}
      groupName={this.groupName}
      selectedColumnsName={subMenuRoute}
      dataFieldName={this.subPages[subMenuRoute].PdApiField}
      setExtraProperties={this.subPages[subMenuRoute].setExtraProperties}
      createEmpty={this.subPages[subMenuRoute].createEmpty}
      columnFilters={this.state.tableColumnFilters[subMenuRoute]}
    />
  );

  private buildLink = (subPageName: State.GroupSubmenu): JSX.Element => {
    // To dynamically build urls we use the itenName and make it plural, so -s || -y => -ies
    let parsedLink = this.subPages[subPageName].itemName.replace(" ", "-");
    parsedLink = parsedLink.slice(-1) === "y" ? parsedLink.slice(0, -1) + "ies" : parsedLink + "s";
    return (
      <NavigationLink
        key={subPageName}
        handleOnClick={() => this.handleLinkClick(subPageName)}
        name={subPageName}
        to={"/" + this.groupName.toLowerCase() + "/" + parsedLink + "/"}
      />
    );
  };

  
    private handleLinkClick = (subPageName: Api.AnyItem) => {
      this.props.editActions.cancelEditing;
      if (subPageName === "Group Faults" && this.props.pdApi.groupFaults === undefined) {
        this.props.pdApiActions.fetchGroupFaults();
      }
    };

  private buildModal = () => {
    const domainName = this.props.domainName ? " Domain: " + this.props.domainName : "";
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.props.subMenuRoute].itemName}?
        <br />
        {this.props.objectIdentifier}
        <br /> {domainName}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() =>
          this.props.editActions.delete(
            this.subPages[this.props.subMenuRoute].PdApiField as Api.OptionsGrud
          )
        }
        onCancel={this.toggleModal}
      />
    );
  };

  /*
   * Toggles the modal based on previous state.
   */
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isLoadingFaults: state.loadingStatus.isGroupFaultsLoading,
  isLoadingParameters: state.loadingStatus.isLoadingParameters,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  domainName: domainSelector(state.editView),
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (
  dispatch: Dispatch<PdApiActions | ColumnActions | EditActions | MainActions>
) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch),
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Group);
